import styled from 'styled-components';
import { calculateGridItemChildWidth } from '../../../commonStyles/innerGridItemColumn';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';
import fluidGridColumns from '../../../theme/fluidGridColumns';
import Icon from '../../Icon';
import Link from '../../Link';
import { actionLinkStyle } from '../../Link/styles';
import RichText from '../../RichText';
import {
  openingHoursGridItemProps,
  phoneInfoGridItemProps,
  splitInfoCardGridItemProps,
} from '../layout';

export const OpeningHoursContainer = styled.div`
  padding-top: ${spacingWithBorder(3, 1)};
  border-top: 1px solid ${colors.neutral04};

  ${mediaQuery.tabletLandscape`
    padding-top: 0;
    padding-left: ${spacingWithBorder(4, 1)};
    border-top: 0;
    border-left: 1px solid ${colors.neutral04};

    width: ${({ theme }) =>
      calculateGridItemChildWidth(
        splitInfoCardGridItemProps.tabletLandscape ?? fluidGridColumns.tabletLandscape,
        openingHoursGridItemProps.tabletLandscape ?? fluidGridColumns.tabletLandscape,
        'tabletLandscape',
        spacing(4)({ theme })
      )};
  `};

  ${mediaQuery.desktop`
    width: ${({ theme }) =>
      calculateGridItemChildWidth(
        splitInfoCardGridItemProps.desktop ?? fluidGridColumns.desktop,
        openingHoursGridItemProps.desktop ?? fluidGridColumns.desktop,
        'desktop',
        spacing(4)({ theme })
      )};
  `}
`;

export const PhoneInfoContainer = styled.div`
  margin-bottom: ${spacingWithBorder(3, 1)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: 0;
    margin-right: ${({ theme }) => theme.layout.tabletLandscape.gutterPx}px;
    width: ${({ theme }) =>
      calculateGridItemChildWidth(
        splitInfoCardGridItemProps.tabletLandscape ?? fluidGridColumns.tabletLandscape,
        phoneInfoGridItemProps.tabletLandscape ?? fluidGridColumns.tabletLandscape,
        'desktop',
        spacing(4)({ theme })
      )};
  `}

  ${mediaQuery.desktop`
    margin-right: ${({ theme }) => theme.layout.desktop.gutterPx}px;
    width: ${({ theme }) =>
      calculateGridItemChildWidth(
        splitInfoCardGridItemProps.desktop ?? fluidGridColumns.desktop,
        phoneInfoGridItemProps.desktop ?? fluidGridColumns.desktop,
        'desktop',
        spacing(4)({ theme })
      )};
  `}
`;

export const HeadingWrapper = styled.div`
  display: flex;
  margin-bottom: ${spacing(2)};
`;

export const StyledIcon = styled(Icon)`
  margin-right: ${spacing(2)};
  color: ${colors.cardIcon};
`;

export const Heading = styled.h3`
  ${fonts.headingSmall};
  margin: 0;
`;

export const PhoneNumber = styled(Link)`
  ${fonts.headingXSmall}
  ${actionLinkStyle}
  text-decoration: underline;

  & {
    color: ${colors.core01};
  }
`;

export const StyledRichText = styled(RichText)`
  h4 {
    margin: 0 0 ${spacing(1)};
    ${mediaQuery.tabletLandscape`
      margin-bottom: ${spacing(2)};
  `};
  }

  overflow-wrap: break-word;
  word-wrap: break-word;

  p,
  p + p {
    margin: 0;
  }
`;

export const Body = styled(RichText)`
  ${fonts.paragraph};
  margin: ${spacing(2)} 0 0;
`;
